import { FormType } from 'Api/Contracts/Dtos/Project/Enums';
import { ITooltipStyle } from 'Framework/Components/Controls/XView/Core';

export type Animation2D = {
    type: AnimationType;
    frameRate: number;
    animationSpeed: number;
}

export type AnimationType =
    | 'beatAnimation'
    | 'fadeAnimation'
    | 'bounceAnimation'
    | 'flipAnimation'
    | 'shakeAnimation'
    | 'spinAnimation'
    | 'beatFadeAnimation'

export interface IIconRenderer {
    type: string,
    icon: string,
    animation?: Animation2D,
    color: string,
    size: string,
    tooltip: string,
    tooltipStyle?: ITooltipStyle
}

export interface IShapeRenderer {
    type: string,
    color: string,
    tooltip: string,
    formType: FormType,
    hoverColor: string,
    selectedColor: string,
    stroke: { color: string, width: number },
    tooltipStyle?: ITooltipStyle
}

export interface ITextRenderer {
    type: 'textRenderer';
    text: string;
    color: string;
    size: number;
    tooltip: string;
    tooltipStyle?: ITooltipStyle;
}

export type IRenderer = IIconRenderer | IShapeRenderer | ITextRenderer;

export class RendererHelper {
    public static isIconRenderer(renderer: IRenderer): renderer is IIconRenderer {
        return renderer
            && (renderer as IIconRenderer).type !== undefined
            && (renderer as IIconRenderer).type === 'iconRenderer';
    }

    public static isShapeRenderer(renderer: IRenderer): renderer is IShapeRenderer {
        return renderer
            && (renderer as IIconRenderer).type !== undefined
            && (renderer as IIconRenderer).type === 'shapeRenderer';
    }

    public static isTextRenderer(renderer: IRenderer): renderer is ITextRenderer {
        return (renderer as ITextRenderer).type === 'textRenderer';
    }
}
